import { transformNullishToNullData } from "@/utils/constants";
const DEFAULT_DATA = () => ({
  id: null,
  type: 'CREATE',
  categories: [],
  themes: [],
  initialDate: null,
  endDate: null,
  file: [],
  selectedFile: null,
  image: [],
  selectedImage: null,
  url: null,
  title: null,
  body: null,
  userId: null,
  visibilityId: null,
  user: null
});
export default {
  state: {
    newsData: DEFAULT_DATA(),
    newsModalInHome: false
  },
  getters: {
    getNewsData(state) {
      return state.newsData;
    },
    getNewsModalInHome(state) {
      return state.newsModalInHome;
    }
  },
  mutations: {
    setNewsData(state, data) {
      state.newsData = transformNullishToNullData({
        recursive: true,
        input: data || DEFAULT_DATA()
      });
    },
    // eslint-disable-next-line no-unused-vars
    clearNewsData(state, _) {
      Object.assign(state.newsData, DEFAULT_DATA());
    },
    setNewsModalInHome(state, status) {
      state.newsModalInHome = status;
    }
  },
  actions: {
    changeNewsData(context, data) {
      context.commit("setNewsData", data);
    },
    clearNewsData({
      commit
    }, data) {
      commit("clearNewsData", data);
    },
    changeNewsModalInHome(context, status) {
      context.commit("setNewsModalInHome", status);
    }
  }
};